module.exports = __webpack_public_path__ + "img/1-1.9538a789.png";